/**
 * 素材类型与互动分析主组件
 * 对应板块: 板块 F — 素材类型与互动分析
 */
import React, { useMemo } from 'react';
import { Row, Col } from 'tea-component';
import TypeTrendChart from './TypeTrendChart';
import type { IMaterialTypeAnalysisProps, TMaterialMetric, TDimensionType } from './types';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
import { getChartMetricLabelKey } from '../../utils/metricLabels';


const MaterialTypeAnalysis: React.FC<IMaterialTypeAnalysisProps> = ({ filter, gameInfo }) => {
  const { formatMessage } = useLanguage();
  // 图表配置
  const CHART_CONFIGS: Array<{
    title: string;
    metric: TMaterialMetric;
    dimensionType: TDimensionType;
  }> = useMemo(() => [
    {
      title: getChartMetricLabelKey('Active Ads by Creative Type', filter),
      metric: 'creative_type_stat',
      dimensionType: 'creativeType',
    },
    {
      title: getChartMetricLabelKey('Cumulative Impressions by Type', filter),
      metric: 'engagement_stat',
      dimensionType: 'engagement',
    },
  ], [filter]);

  return (
    <div className="dbo-material-type-analysis">
      <Row gap={20}>
        {CHART_CONFIGS.map((config) => (
          <Col span={12} key={config.metric}>
            <TypeTrendChart
              title={formatMessage({ id: config.title })}
              metric={config.metric}
              dimensionType={config.dimensionType}
              filter={filter}
              gameInfo={gameInfo}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default React.memo(MaterialTypeAnalysis);
